/* src/app/artic-run-diary/pages/artic-add-job-details/artic-add-job-details.component.scss */
/*# sourceMappingURL=artic-add-job-details.component.css.map */
